"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _agGridReact = require("ag-grid-react");

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var _LoadingOverlay = _interopRequireDefault(require("./LoadingOverlay"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'DataGrid');
var defaultOptions = {
  rowHeight: 50,
  headerHeight: 40,
  enableCellTextSelection: true,
  suppressRowClickSelection: true,
  suppressCellSelection: true,
  suppressRowDrag: true,
  suppressMovableColumns: true,
  suppressClickEdit: true,
  suppressScrollOnNewData: true,
  suppressAnimationFrame: true,
  suppressContextMenu: true,
  animateRows: false,
  rowDataChangeDetectionStrategy: 'IdentityCheck',
  defaultColDef: {
    resizable: true
  },
  columnDefs: [],
  rowData: [],
  reactNext: true
};

function DataGrid(_ref) {
  var id = _ref.id,
      classesProp = _ref.classes,
      className = _ref.className,
      dataSource = _ref.dataSource,
      isLoading = _ref.isLoading,
      hasError = _ref.hasError,
      vanillaComponents = _ref.vanillaComponents,
      components = _ref.components,
      onReady = _ref.onReady,
      infiniteInitialRowCount = _ref.infiniteInitialRowCount,
      props = (0, _objectWithoutProperties2.default)(_ref, ["id", "classes", "className", "dataSource", "isLoading", "hasError", "vanillaComponents", "components", "onReady", "infiniteInitialRowCount"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);
  var rootClassName = (0, _classnames.default)(classes.root, className, 'ag-theme-balham');
  var gridRef = (0, _react.useRef)(null);
  var gridWidthRef = (0, _react.useRef)(0); // Main events

  var onGridReady = (0, _react.useCallback)(function (params) {
    gridRef.current = params;
    onReady && onReady(params);
  }, [onReady]);
  var onGridSizeChanged = (0, _react.useCallback)(function (params) {
    var clientWidth = gridWidthRef.current;
    gridWidthRef.current = params.clientWidth;
    if (params.clientWidth && clientWidth && params.clientwidth === clientWidth) return;
    params.api.sizeColumnsToFit();
  }, []);
  var onFirstDataRendered = (0, _react.useCallback)(function (params) {
    if (params && params.api && params.api.sizeColumnsToFit) {
      params.api.sizeColumnsToFit();
    }
  }, []);
  var options = (0, _react.useMemo)(function () {
    var options = (0, _extends2.default)({}, defaultOptions, {
      frameworkComponents: (0, _extends2.default)({
        loadingOverlay: function loadingOverlay() {
          for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
            props[_key] = arguments[_key];
          }

          return /*#__PURE__*/_react.default.createElement(_LoadingOverlay.default, props);
        }
      }, components),
      components: (0, _extends2.default)({}, vanillaComponents),
      loadingOverlayComponent: 'loadingOverlay',
      noRowsOverlayComponent: 'noRowsOverlay'
    }, props);

    if (dataSource) {
      options.rowModelType = 'infinite';
      options.datasource = dataSource;
    }

    return options;
  }, [components, dataSource, props, vanillaComponents]);
  (0, _react.useEffect)(function () {
    if (gridRef && gridRef.current && gridRef.current.api && gridRef.current.api.setInfiniteRowCount) {
      gridRef.current.api.setInfiniteRowCount(infiniteInitialRowCount);
    }
  }, [infiniteInitialRowCount]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_agGridReact.AgGridReact, (0, _extends2.default)({
    onGridReady: onGridReady,
    onGridSizeChanged: onGridSizeChanged,
    onFirstDataRendered: onFirstDataRendered,
    infiniteInitialRowCount: infiniteInitialRowCount
  }, options)));
}

DataGrid.defaultProps = {
  rowData: null,
  vanillaComponents: {},
  components: {}
};
process.env.NODE_ENV !== "production" ? DataGrid.propTypes = {
  className: _propTypes.default.string
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(DataGrid);

exports.default = _default;